// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SecurityContainer_YsuK5 {

}
.infolabel_YeHPV{
  flex-direction: column;
}
.securityLabel_MjpjW {
  border-bottom: 1px solid #0000001a;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0;
  gap: 10px;

  @media (width<=768px) {
    flex-direction: column;
  }
  .rightSide_Fx7w5 {
    width: 70%;
    .inputWrapper_hz8EY {
      display: flex;
      align-items: center;
      background-color: var(--f4-background);
      box-sizing: border-box;
      padding: 12px;
      border-radius: 6px;
      -webkit-border-radius: 6px;
      -moz-border-radius: 6px;
      -ms-border-radius: 6px;
      -o-border-radius: 6px;
      input {
        background-color: transparent;
        border: none;
        outline: none;
      }
      svg{
        width: 20px;
        height: 20px;
        margin-right: 20px;
      }
    }
    .disabled_IBYsb{
      background-color: transparent;
    }
  }

  .title_G68g7{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .info_o2HK_ {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    align-items: center;
    p {
      margin: 0;
      color: #0d0d0d;
    }
    span {
      color: #717171;
      font-size: 13px;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/GeneralSettings/components/Security/Security.module.css"],"names":[],"mappings":"AAAA;;AAEA;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,SAAS;;EAET;IACE,sBAAsB;EACxB;EACA;IACE,UAAU;IACV;MACE,aAAa;MACb,mBAAmB;MACnB,sCAAsC;MACtC,sBAAsB;MACtB,aAAa;MACb,kBAAkB;MAClB,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;MACrB;QACE,6BAA6B;QAC7B,YAAY;QACZ,aAAa;MACf;MACA;QACE,WAAW;QACX,YAAY;QACZ,kBAAkB;MACpB;IACF;IACA;MACE,6BAA6B;IAC/B;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;EACb;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB;MACE,SAAS;MACT,cAAc;IAChB;IACA;MACE,cAAc;MACd,eAAe;IACjB;EACF;AACF","sourcesContent":[".SecurityContainer {\n\n}\n.infolabel{\n  flex-direction: column;\n}\n.securityLabel {\n  border-bottom: 1px solid #0000001a;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 5px 0;\n  gap: 10px;\n\n  @media (width<=768px) {\n    flex-direction: column;\n  }\n  .rightSide {\n    width: 70%;\n    .inputWrapper {\n      display: flex;\n      align-items: center;\n      background-color: var(--f4-background);\n      box-sizing: border-box;\n      padding: 12px;\n      border-radius: 6px;\n      -webkit-border-radius: 6px;\n      -moz-border-radius: 6px;\n      -ms-border-radius: 6px;\n      -o-border-radius: 6px;\n      input {\n        background-color: transparent;\n        border: none;\n        outline: none;\n      }\n      svg{\n        width: 20px;\n        height: 20px;\n        margin-right: 20px;\n      }\n    }\n    .disabled{\n      background-color: transparent;\n    }\n  }\n\n  .title{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n  }\n  .info {\n    display: flex;\n    justify-content: space-between;\n    gap: 10px;\n    align-items: center;\n    p {\n      margin: 0;\n      color: #0d0d0d;\n    }\n    span {\n      color: #717171;\n      font-size: 13px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"SecurityContainer": `SecurityContainer_YsuK5`,
	"infolabel": `infolabel_YeHPV`,
	"securityLabel": `securityLabel_MjpjW`,
	"rightSide": `rightSide_Fx7w5`,
	"inputWrapper": `inputWrapper_hz8EY`,
	"disabled": `disabled_IBYsb`,
	"title": `title_G68g7`,
	"info": `info_o2HK_`
};
export default ___CSS_LOADER_EXPORT___;
